module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    attrs: {
      "id": "got-award"
    }
  }, [_c('div', {
    staticClass: "mask",
    on: {
      "touchmove": _vm.touchMove
    }
  }, [_c('div', {
    class: ['content', _vm.code ? 'code' : '']
  }, [_c('div', {
    staticClass: "title"
  }, [_c('p', {
    staticClass: "of"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('p', {
    staticClass: "of"
  }, [_vm._v("有效期" + _vm._s(_vm._f("time")(_vm.coupon.startTime)) + " - " + _vm._s(_vm._f("time")(_vm.coupon.endTime)))])]), _vm._v(" "), _c('div', {
    staticClass: "img",
    style: ({
      backgroundImage: ("url(" + _vm.img + ")")
    })
  }), _vm._v(" "), (_vm.awardType === 1) ? _c('div', [(!_vm.code) ? _c('router-link', {
    staticClass: "link",
    attrs: {
      "tag": "div",
      "to": {
        path: '/info',
        query: {
          awardId: _vm.awardId,
          from: 'turnplate'
        }
      }
    }
  }, [_c('div', {
    staticClass: "get-code",
    attrs: {
      "data-awardid": _vm.awardId
    }
  }, [_vm._v("获取兑奖码>>")])]) : _c('router-link', {
    staticClass: "link",
    attrs: {
      "tag": "div",
      "to": {
        path: '/awards'
      }
    }
  }, [_c('div', {
    staticClass: "show-code"
  }, [_vm._v("兑奖码:" + _vm._s(_vm.code))])]), _vm._v(" ")]) : (_vm.awardType === 2) ? _c('div', [_c('div', {
    staticClass: "link"
  }, [_c('a', {
    staticClass: "go-coupon",
    attrs: {
      "href": _vm.couponLink
    }
  }, [_vm._v("立即使用")])])]) : _vm._e(), _vm._v(" "), _vm._v(" "), _c('i', {
    staticClass: "cancel",
    on: {
      "click": _vm.cancel
    }
  })])])]) : _vm._e()
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-loader/lib/template-compiler.js?id=data-v-4f11564b!../~/vue-loader/lib/selector.js?type=template&index=0!./components/vue/getaward-new.vue
 ** module id = 179
 ** module chunks = 3
 **/